import { useEffect, useState } from 'react';
import { CustomPaper } from '../styles';
import { db } from '../../../services/firebase.config';
import { collection, getDocs, updateDoc, doc } from "firebase/firestore";
import { Palmares } from '../../../interfaces/otherInterfance';
import { Button, TextField, Tab, Tabs, CircularProgress } from '@mui/material';
import CowPart from './Cows/CowPart';
import EventPart from './Events/EventPart';

const ConcoursPart = () => {
	const [palmares, setPalmares] = useState<Palmares>(); // Palmares obtenu depuis la base de données
	const [textFieldContent, setTextFieldContent] = useState<string>(); // Contenu de la zone de texte
	const [selectedTab, setSelectedTab] = useState<number>(0); // Tabs permettant de séparer la partie "Mettre à jour" de la partie "Enregistré"

	useEffect(() => {
		// Récupération du palmarès
		const fetchData = async () => {
			const data = await getDocs(collection(db, "palmares"));
			setPalmares({ ...data.docs[0].data(), id: data.docs[0].id } as Palmares);
			setTextFieldContent(data.docs[0].data().palmares);
		};

		fetchData();
	}, []);

	// Mise à jour du palmarès (au clic sur le bouton "Valider")
	const handleUpload = async () => {
		// Si le palmarès n'existe pas, on ne fait rien
		if (!palmares?.id) {
			return;
		}
		// On met à jour le palmarès si le contenu de la zone de texte n'est pas vide
		if (textFieldContent) {
			await updateDoc(doc(db, "palmares", palmares?.id), {
				palmares: textFieldContent
			});
		}
	};

	// Si le palmarès n'est pas encore chargé, on affiche un loader
	if (!palmares) {
		return (
			<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
				<CircularProgress />
			</div>
		);
	}

	// Sinon, on affiche le palmarès
	return (
		<CustomPaper>
			<Tabs value={selectedTab} onChange={(event, newValue) => setSelectedTab(newValue)}>
				<Tab label="Mettre à jour" />
				<Tab label="Enregistré" />
				<Tab label="Vaches" />
				<Tab label="Évènements" />
			</Tabs>

			{selectedTab === 0 && ( // On affiche la zone de texte
				<header style={{ width: '100%' }}>
					<TextField
						fullWidth
						multiline
						rows={25}
						placeholder="Collez le HTML du palmarès ici"
						id="textFieldContent"
						defaultValue={textFieldContent}
						onChange={(e) => setTextFieldContent(e.target.value)}
					/>

					<Button variant="contained" color="primary" fullWidth onClick={handleUpload}>Valider</Button>
				</header>
			)}

			{selectedTab === 1 && ( // On affiche le palmarès
				<p dangerouslySetInnerHTML={{ __html: palmares?.palmares }}></p>
			)}

			{selectedTab === 2 && (
				<CowPart />
			)}

			{selectedTab === 3 && (
				<EventPart />
			)}
		</CustomPaper>
	);
};

export default ConcoursPart;